import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';


const StudentProvider = (props) => {
  const api = new API();
  const [fetchStudentList, setFetchStudentList] = useState([]);
  const [tableFilter, setTableFilter] = useState({
    name: '',
    version: '',
    sub_category: [],
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
    college: '',
    state: '',
    startDate: '',
    endDate: '',
    page: 1,
    limit: 20
  })
  const [fetchStudentSessionList, setFetchStudentSessionList] = useState([]);
  const [fetchStudentSessionLoader, setFetchStudentSessionLoader] = useState(false);
  const [tableFilterSession, setTableFilterSession] = useState({
    name: '',
    page: 1,
    limit: 20
  })
  const [fetchStudentPaymentsList, setFetchStudentPaymentsList] = useState([]);
  const [fetchStudentPaymentsLoader, setFetchStudentPaymentsLoader] = useState(false);
  const [tableFilterPayments, setTableFilterPayments] = useState({
    name: '',
    page: 1,
    limit: 20
  })
  const [fetchStudentDeviceList, setFetchStudentDeviceList] = useState([]);
  const [fetchStudentDeviceLoader, setFetchStudentDeviceLoader] = useState(false);
  const [tableFilterDevice, setTableFilterDevice] = useState({
    name: '',
    page: 1,
    limit: 20
  })
  const [fetchStudentAttemptList, setFetchStudentAttemptList] = useState([]);
  const [fetchStudentAttemptLoader, setFetchStudentAttemptLoader] = useState(false);
  const [tableFilterAttempt, setTableFilterAttempt] = useState({
    name: '',
    page: 1,
    limit: 20
  })
  const [fetchStudentExportList, setFetchStudentExportList] = useState([]);
  const [fetchStudentExportLoader, setFetchStudentExportLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [singleStudentData, setSingleStudentData] = useState({});
  const [singleStudentLoader, setSingleStudentLoader] = useState(false);
  const [singleStudentDeleteLoader, setSingleStudentDeleteLoader] = useState(false);
  const [deviceRemoveLoader, setDeviceRemoveLoader] = useState(false);
  const [deviceRemoveAllLoader, setDeviceRemoveAllLoader] = useState(false);
  const [deviceApprovedLoader, setDeviceApprovedLoader] = useState(false);
  const [linkPlanList, setLinkPlanList] = useState([]);
  const [linkPlanLoader, setLinkPlanLoader] = useState(false);
  const [linkPlanDurationList, setLinkPlanDurationList] = useState([]);
  const [generateLinkLoader, setGenerateLinkLoader] = useState(false);
  const [generateLinkData, setGenerateLinkData] = useState({});
  const [deviceBlockLoader, setDeviceBlockLoader] = useState(false);


  const fetchLinkPlanDurationList = async (val) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      setGenerateLinkLoader(true);
    (await api.create(`link/create_payment_link`, val, (err, res) => {
      if (res?.data?.status === 200) {
        setGenerateLinkData(res?.data?.data);
      } else {
        setGenerateLinkData({});
        Widget.showMessage("error", err?.response?.data?.message);
      }
      setGenerateLinkLoader(false);
    }));
  };

  const fetchLinkPlanList = async () => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      setLinkPlanLoader(true);
    (await api.getAll(`link/plan_list`, {}, (err, res) => {
      if (res?.data?.status === 200) {
        setLinkPlanList(res?.data?.data);
      } else {
        Widget.showMessage("error", err?.response?.data?.message);
      }
      setLinkPlanLoader(false);
    }));
  };




  const removeSingleDevice = async (id, sid) => {
    setDeviceRemoveLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update(`student/student_device/remove`, id, {}, (err, res) => {
        if (res?.data?.status === 200) {
          fetchStudentDevice(sid);
          Widget.showMessage("success", res?.data?.message);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setDeviceRemoveLoader(false);
      }));
  };
  const removeAllDevice = async (id, sid) => {
    setDeviceApprovedLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update(`student/student_device/remove_all`, id, {}, (err, res) => {
        if (res?.data?.status === 200) {
          fetchStudentDevice(sid);
          Widget.showMessage("success", res?.data?.message);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setDeviceApprovedLoader(false);
      }));
  };
  const updateDeviceStatus = async (id, status, sid) => {
    setDeviceRemoveAllLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update(`student/student_device/status`, id, {
        approvel_status: status
      }, (err, res) => {
        if (res?.data?.status === 200) {
          fetchStudentDevice(sid);
          Widget.showMessage("success", res?.data?.message);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setDeviceRemoveAllLoader(false);
      }));
  };
  const updateDeviceStatusBlock = async (id, status, sid) => {
    setDeviceBlockLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update(`student/student_device/block`, id, {
        is_blocked: status
      }, (err, res) => {
        if (res?.data?.status === 200) {
          fetchStudentAttempt(sid);
          fetchStudentDevice(sid);
          Widget.showMessage("success", res?.data?.message);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setDeviceBlockLoader(false);
      }));
  };
  const fetchStudent = async () => {
    setLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("student", { ...tableFilter }, (err, res) => {
        setLoader(false);
        if (res?.data?.status === 200) {
          setFetchStudentList(res?.data?.data);
        } else {
          setFetchStudentList([]);
        }
      }));
  };
  const fetchExportStudent = async (limit) => {
    setFetchStudentExportLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("student", { ...tableFilter, limit: limit, page: 1 }, (err, res) => {
        setFetchStudentExportLoader(false);
        if (res?.data?.status === 200) {
          setFetchStudentExportList(res?.data?.data?.data);
        } else {
          setFetchStudentExportList([]);
        }
      }));
  };
  const fetchStudentSession = async (id) => {
    setFetchStudentSessionLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll(`student/session/${id}`, { ...tableFilterSession }, (err, res) => {
        if (res?.data?.status === 200) {
          setFetchStudentSessionList(res?.data?.data);
        } else {
          setFetchStudentSessionList([]);
        }
        setFetchStudentSessionLoader(false);
      }));
  };
  const fetchStudentPayments = async (id) => {
    setFetchStudentPaymentsLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll(`student/payments/${id}`, { ...tableFilterPayments }, (err, res) => {
        if (res?.data?.status === 200) {
          setFetchStudentPaymentsList(res?.data?.data);
        } else {
          setFetchStudentPaymentsList([]);
        }
        setFetchStudentPaymentsLoader(false);
      }));
  };
  const fetchStudentDevice = async (id) => {
    setFetchStudentDeviceLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll(`student/student_device/${id}`, { ...tableFilterDevice }, (err, res) => {
        if (res?.data?.status === 200) {
          setFetchStudentDeviceList(res?.data?.data);
        } else {
          setFetchStudentDeviceList([]);
        }
        setFetchStudentDeviceLoader(false);
      }));
  };
  const fetchSingleStudent = async (id) => {
    if (!id) return;
    setSingleStudentData({});
    setSingleStudentLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getSingle("student/single", id, (err, res) => {
        if (res?.data?.status === 200) {
          setSingleStudentData(res?.data?.data);
        } else {
          setSingleStudentData({});
        }
        setSingleStudentLoader(false);
      }));
  };
  const deleteSingleStudent = async (id) => {
    if (!id) return;
    setSingleStudentDeleteLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.remove("student/delete", id, (err, res) => {
        if (res?.data?.status === 200) {
          fetchStudent();
        } else {
          Widget.showMessage("error", err?.response?.data?.message || "Something went wrong");
        }
        setSingleStudentDeleteLoader(false);
      }));
  };
  const fetchStudentAttempt = async (id) => {
    setFetchStudentAttemptLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll(`student/student_parallel_attempt/${id}`, { ...tableFilterAttempt }, (err, res) => {
        if (res?.data?.status === 200) {
          setFetchStudentAttemptList(res?.data?.data);
        } else {
          setFetchStudentAttemptList([]);
        }
        setFetchStudentAttemptLoader(false);
      }));
  };

  return (
    <Context.Provider value={{
      ...props,
      fetchStudentList,
      fetchStudent,
      loader,
      tableFilter,
      setTableFilter,
      singleStudentData, setSingleStudentData,
      singleStudentLoader, setSingleStudentLoader,
      fetchSingleStudent,
      singleStudentDeleteLoader, setSingleStudentDeleteLoader,
      deleteSingleStudent,
      fetchStudentSession,
      fetchStudentSessionLoader, setFetchStudentSessionLoader,
      fetchStudentSessionList, setFetchStudentSessionList,
      tableFilterSession, setTableFilterSession,
      fetchStudentPayments,
      fetchStudentPaymentsLoader, setFetchStudentPaymentsLoader,
      fetchStudentPaymentsList, setFetchStudentPaymentsList,
      tableFilterPayments, setTableFilterPayments,
      fetchStudentDevice,
      fetchStudentDeviceLoader, setFetchStudentDeviceLoader,
      fetchStudentDeviceList, setFetchStudentDeviceList,
      tableFilterDevice, setTableFilterDevice,
      removeSingleDevice,
      removeAllDevice,
      updateDeviceStatus,
      deviceRemoveAllLoader, setDeviceRemoveAllLoader,
      deviceRemoveLoader, setDeviceRemoveLoader,
      deviceApprovedLoader, setDeviceApprovedLoader,
      linkPlanList, setLinkPlanList,
      linkPlanLoader, setLinkPlanLoader,
      linkPlanDurationList, setLinkPlanDurationList,
      fetchLinkPlanList,
      generateLinkLoader, setGenerateLinkLoader,
      generateLinkData, setGenerateLinkData,
      fetchLinkPlanDurationList,
      fetchStudentExportList,
      fetchStudentExportLoader,
      fetchExportStudent,
      setFetchStudentExportList,
      fetchStudentAttempt,
      fetchStudentAttemptLoader,
      fetchStudentAttemptList,
      tableFilterAttempt,
      setTableFilterAttempt,
      deviceBlockLoader, setDeviceBlockLoader,
      updateDeviceStatusBlock,
    }}>
      {props.children}
    </Context.Provider>
  )
};

export default StudentProvider;
